<template>
  <div id="vendor-partners" class="h-margin-top-50">
    <div v-if="loaders.vendors" class="loading-indicator"><MoonLoader size="75px" color="#ffffff"></MoonLoader></div>
    <VendorPartnerships></VendorPartnerships>
  </div>

</template>

<script>
  import { mapGetters } from 'vuex';
  import { MoonLoader } from 'vue-spinner/dist/vue-spinner.min.js';
  import VendorPartnerships from '../vendor-partners/VendorPartnerships.vue';

  export default {
    name: 'VendorPartnersLayout',
    components: {
      MoonLoader,
      VendorPartnerships,
    },
    computed: {
      ...mapGetters('vendorPartners', ['loaders', 'initializers']),
    },
    beforeMount() {
      if (!this.initializers.vendors) {
        this.$store.dispatch('vendorPartners/getVendors');
      }
    },
    mounted() {
      this.$store.dispatch('main/setProperty', { key: 'globalLoading', value: false });
    },
  };
</script>
